<div
  class="language-switcher inline-flex bg-background items-center rounded-lg p-0.5"
  role="group"
  [attr.aria-label]="'header.language.switchAria' | translate"
>
  @for (lang of languages; track lang) {
    <button
      type="button"
      class="language-switcher__option min-w-[2.25rem] p-2 text-xs font-medium transition-colors"
      [class.language-switcher__option--active]="isActive(lang)"
      [class.rounded-l-lg]="isActive(lang) && !isFirst(lang)"
      [class.rounded-r-lg]="isActive(lang) && !isLast(lang)"
      [attr.aria-pressed]="isActive(lang)"
      (click)="select(lang)"
    >
      {{ 'header.language.' + lang | translate }}
    </button>
  }
</div>
